import { tva } from '@gluestack-ui/utils/nativewind-utils'
import React from 'react'

import { Box } from '../box'

export type StatusStripeStatus =
    | 'critical'
    | 'caution'
    | 'success'
    | 'neutral'
    | 'info'
    | 'neutral-muted'
    | 'warning'

export type StatusStripeProps = {
    status: StatusStripeStatus
    className?: string
    testID?: string
}

const statusStripe = tva({
    base: 'w-1 self-stretch rounded-full',
    variants: {
        status: {
            'critical': 'bg-status-critical',
            'caution': 'bg-status-caution',
            'success': 'bg-status-success',
            'neutral': 'bg-status-neutral',
            'info': 'bg-status-info',
            'neutral-muted': 'bg-status-neutral-muted',
            'warning': 'bg-status-warning',
        },
    },
})

/**
 * Vertical status stripe matching the Figma redesign (AOS-606): a 4px-wide
 * rounded bar in the status colour, used as a leading accent on cards and list
 * rows. Stretches to its parent's height by default (`self-stretch`); override
 * the height via `className` (e.g. `h-24`).
 */
export const StatusStripe: React.FC<StatusStripeProps> = ({ status, className, testID }) => (
    <Box
        className={statusStripe({ status, class: className })}
        accessibilityLabel={status}
        testID={testID}
    />
)

StatusStripe.displayName = 'StatusStripe'
